var _style, _rect, _path, _path2, _g, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBannerBox(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "OBJECTS",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 181.2 208.3",
    style: {
      enableBackground: "new 0 0 181.2 208.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:url(#SVGID_1_);}\r\n\t.st1{fill:url(#SVGID_00000027598723583626827330000014227104784729741500_);}\r\n\t.st2{fill:url(#SVGID_00000145038597202164966130000002965110174263346619_);}\r\n\t.st3{fill:url(#SVGID_00000006693915010569967190000007284590791387640484_);}\r\n\t.st4{fill:url(#SVGID_00000140002456019997565040000010156332779395666872_);}\r\n\t.st5{fill:url(#SVGID_00000039114528736373577530000016579354384235026049_);}\r\n\t.st6{fill:url(#SVGID_00000039840966139704362850000000766418512257302414_);}\r\n\t.st7{fill:url(#SVGID_00000044889926456575294420000008576534443196500927_);}\r\n\t.st8{fill:url(#SVGID_00000152246297458874913790000000639401970657638272_);}\r\n\t.st9{fill:url(#SVGID_00000108288260727763072740000008564886134526429618_);}\r\n\t.st10{fill:url(#SVGID_00000159462208205246302720000011187107450323660974_);}\r\n\t.st11{fill:url(#SVGID_00000044157206999461714640000002592964359923018132_);}\r\n\t.st12{fill:url(#SVGID_00000035504291090474859330000011834275189905423767_);}\r\n\t.st13{fill:url(#SVGID_00000086658362991593774110000002187673471096755342_);}\r\n\t.st14{fill:url(#SVGID_00000163073339367116907560000007206483980667330210_);}\r\n\t.st15{fill:#01372B;}\r\n\t.st16{fill:url(#SVGID_00000137113382658431232010000017641835031036631990_);}\r\n\t.st17{fill:url(#SVGID_00000126291326186245918120000015299883244428755359_);}\r\n\t.st18{fill:#FFFFFF;}\r\n\t.st19{opacity:0.7;}\r\n\t.st20{fill:url(#SVGID_00000049200420696192374860000014580486696321948806_);}\r\n\t.st21{fill:url(#SVGID_00000112601169462172223580000015883208806437685691_);}\r\n\t.st22{fill:url(#SVGID_00000029006556735302717790000012429756019091937421_);}\r\n\t.st23{fill:url(#SVGID_00000150801424782902248380000015292117221207159735_);}\r\n\t.st24{fill:url(#SVGID_00000168823738265680970270000014768710082203919505_);}\r\n\t.st25{fill:url(#SVGID_00000178197304346642983980000016282860988725367951_);}\r\n\t.st26{fill:url(#SVGID_00000042014000153317247910000013082567855343450265_);}\r\n\t.st27{fill:url(#SVGID_00000060006622467996944450000004593805832883374999_);}\r\n\t.st28{fill:url(#SVGID_00000017482635827475570120000014756671728327983515_);}\r\n\t.st29{display:none;opacity:0.2;fill:url(#SVGID_00000114070336478212526490000006636725005125389956_);}\r\n\t.st30{fill:url(#SVGID_00000078038913108632448030000007539615259470165422_);}\r\n\t.st31{fill:url(#SVGID_00000029750996163262389570000013214996438874453651_);}\r\n\t.st32{fill:url(#SVGID_00000101788246748321149850000013775335281341079725_);}\r\n\t.st33{fill:url(#SVGID_00000083787294543631526450000009670507141461300101_);}\r\n\t.st34{fill:url(#SVGID_00000121255306244408637970000004255412207335133571_);}\r\n\t.st35{fill:url(#SVGID_00000042725410035285659060000017476699751696615871_);}\r\n\t.st36{fill:url(#SVGID_00000181790701299245132490000013710313710390986627_);}\r\n\t.st37{fill:url(#SVGID_00000128472835678199611360000006848869187945800577_);}\r\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 46.8115,
    y1: 202.2478,
    x2: 46.8115,
    y2: 97.401
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 5.327789e-8,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00C39A",
      stopOpacity: 0.2
    }
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 39.1,
    y: 117.3,
    className: "st0",
    width: 15.5,
    height: 15.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000018202158146178528910000006876025821491360953_",
    gradientUnits: "userSpaceOnUse",
    x1: 55.6062,
    y1: 202.2477,
    x2: 55.6062,
    y2: 97.4012
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 5.327789e-8,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00C39A",
      stopOpacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000018202158146178528910000006876025821491360953_)"
    },
    points: "71.9,115.6 60.5,115.6  60.5,127 61.4,127 61.4,132.8 57.9,132.8 57.9,139.7 61.4,139.7 61.4,144.8 53,144.8 53,146.9 34.8,146.9 34.8,165.7 42,165.7  42,167.7 21.6,167.7 21.6,199.1 53,199.1 53,193.5 71.6,193.5 71.6,163.8 53.6,163.8 53.6,159.2 57.9,159.2 57.9,154.3  62.5,154.3 62.5,151.7 89.6,151.7 89.6,123.5 71.9,123.5  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000042001802377942300330000003802083515017336963_",
    gradientUnits: "userSpaceOnUse",
    x1: 41.9531,
    y1: 202.2479,
    x2: 41.9531,
    y2: 97.4012
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 5.327789e-8,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00C39A",
      stopOpacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 39.1,
    y: 71.5,
    style: {
      fill: "url(#SVGID_00000042001802377942300330000003802083515017336963_)"
    },
    width: 5.8,
    height: 5.8
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000143585791030878550010000007969025426646709433_",
    gradientUnits: "userSpaceOnUse",
    x1: 57.068,
    y1: 202.2477,
    x2: 57.068,
    y2: 97.401
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 5.327789e-8,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00C39A",
      stopOpacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 53.6,
    y: 59.5,
    style: {
      fill: "url(#SVGID_00000143585791030878550010000007969025426646709433_)"
    },
    width: 6.9,
    height: 6.9
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000062896414745469250520000007366980973704778660_",
    gradientUnits: "userSpaceOnUse",
    x1: 157.9624,
    y1: 202.248,
    x2: 157.9624,
    y2: 97.4013
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 5.327789e-8,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00C39A",
      stopOpacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 142,
    y: 71.5,
    style: {
      fill: "url(#SVGID_00000062896414745469250520000007366980973704778660_)"
    },
    width: 31.9,
    height: 31.9
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000121995475791116848050000011292849074306720658_",
    gradientUnits: "userSpaceOnUse",
    x1: 173.9364,
    y1: 202.2472,
    x2: 173.9364,
    y2: 97.4013
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 5.327789e-8,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00C39A",
      stopOpacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 172.6,
    y: 133,
    style: {
      fill: "url(#SVGID_00000121995475791116848050000011292849074306720658_)"
    },
    width: 2.6,
    height: 2.6
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000023262412202102534960000001665251005266912165_",
    gradientUnits: "userSpaceOnUse",
    x1: 124.2336,
    y1: 202.2485,
    x2: 124.2336,
    y2: 97.4018
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 5.327789e-8,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00C39A",
      stopOpacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 121,
    y: 56.3,
    style: {
      fill: "url(#SVGID_00000023262412202102534960000001665251005266912165_)"
    },
    width: 6.5,
    height: 6.5
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000078751584021808035830000017348456571620730805_",
    gradientUnits: "userSpaceOnUse",
    x1: 150.1384,
    y1: 202.2478,
    x2: 150.1384,
    y2: 97.401
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 5.327789e-8,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00C39A",
      stopOpacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 147.4,
    y: 41.3,
    style: {
      fill: "url(#SVGID_00000078751584021808035830000017348456571620730805_)"
    },
    width: 5.5,
    height: 5.5
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000160885516010895580150000011066055946100327070_",
    gradientUnits: "userSpaceOnUse",
    x1: 153.3712,
    y1: 202.2477,
    x2: 153.3712,
    y2: 97.4014
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 5.327789e-8,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00C39A",
      stopOpacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000160885516010895580150000011066055946100327070_)"
    },
    points: "181.2,154.3 167.5,154.3  167.5,122.5 165.2,122.5 165.2,111.3 149.4,111.3 149.4,122.5 125.6,122.5 125.6,164.5 144.6,164.5 144.6,190.9 158,190.9  158,199.1 177.1,199.1 177.1,190.9 181.2,190.9  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000128479813778563241490000006541569384191381661_",
    gradientUnits: "userSpaceOnUse",
    x1: 54.6725,
    y1: 202.2486,
    x2: 54.6725,
    y2: 97.4012
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 5.327789e-8,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00C39A",
      stopOpacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 88.9,
    style: {
      fill: "url(#SVGID_00000128479813778563241490000006541569384191381661_)"
    },
    width: 3.3,
    height: 3.3
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000105398177809091811440000018009009889472448391_",
    gradientUnits: "userSpaceOnUse",
    x1: 67.8282,
    y1: 202.2475,
    x2: 67.8282,
    y2: 97.4011
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 5.327789e-8,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00C39A",
      stopOpacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 62.5,
    y: 70.6,
    style: {
      fill: "url(#SVGID_00000105398177809091811440000018009009889472448391_)"
    },
    width: 10.6,
    height: 10.6
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000180354271895380197530000001919401480936527233_",
    gradientUnits: "userSpaceOnUse",
    x1: 73.8055,
    y1: 202.2511,
    x2: 73.8055,
    y2: 97.4022
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 5.327789e-8,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00C39A",
      stopOpacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 71.9,
    y: 44,
    style: {
      fill: "url(#SVGID_00000180354271895380197530000001919401480936527233_)"
    },
    width: 3.9,
    height: 3.9
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000101093511712472026770000004066139288495263404_",
    gradientUnits: "userSpaceOnUse",
    x1: 149.9601,
    y1: 202.2477,
    x2: 149.9601,
    y2: 97.4011
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 5.327789e-8,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00C39A",
      stopOpacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 147.4,
    y: 57.8,
    style: {
      fill: "url(#SVGID_00000101093511712472026770000004066139288495263404_)"
    },
    width: 5.1,
    height: 5.1
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000148647119127991905670000002125609015230611584_",
    gradientUnits: "userSpaceOnUse",
    x1: 45.2033,
    y1: 202.245,
    x2: 45.2033,
    y2: 97.4012
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 5.327789e-8,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00C39A",
      stopOpacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 44.2,
    y: 100.4,
    style: {
      fill: "url(#SVGID_00000148647119127991905670000002125609015230611584_)"
    },
    width: 1.9,
    height: 1.9
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000032639480617822035010000001309800403559066525_",
    gradientUnits: "userSpaceOnUse",
    x1: 30.776,
    y1: 202.2484,
    x2: 30.776,
    y2: 97.4007
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 5.327789e-8,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00C39A",
      stopOpacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 28.2,
    y: 139.7,
    style: {
      fill: "url(#SVGID_00000032639480617822035010000001309800403559066525_)"
    },
    width: 5.1,
    height: 5.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M65.4,132.8c-0.4,1.4-0.8,2.9-0.5,4.3c0.4,1.8,1.7,3.3,3.1,4.6c4,3.8,8.2,7.4,12.7,10.7 c5,3.7,10.8,7.2,17,7.1c3.3-0.1,6.5-1.2,9.8-1.1c3,0,5.8,1,8.7,1.6c2.9,0.6,6.1,0.7,8.6-0.7c1.1-0.6,2.1-1.5,3-2.4 c4.3-4.1,8.6-8.2,12.9-12.2c2-1.9,4-3.8,5-6.3c0.9-2,1-4.3,1-6.5c-0.2-10.5-5.1-20.3-10.1-29.4c-4.1-7.3-8.4-14.5-13.5-21.1 c-1.6-2-3.3-4.1-5.5-5.4c-3.4-2-7.6-2.2-11.5-1.4c-3.9,0.8-7.5,2.4-11.3,3.7c-4,1.5-9.5,1.8-13.2,3.8c-2.7,1.5-1.7,4.3-2.3,6.9 c-2,9.4-6.3,18.9-9.2,28.1C68.4,122.3,66.9,127.5,65.4,132.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000030451514104466328390000006150239077626415513_",
    gradientUnits: "userSpaceOnUse",
    x1: 108.8292,
    y1: 228.7339,
    x2: 108.8292,
    y2: 166.4553
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 4.795011e-8,
    style: {
      stopColor: "#282828"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2F2F2F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000030451514104466328390000006150239077626415513_)"
    },
    d: "M176.7,195.2H40.9 c1.2-11,3.8-21.8,8-31.3c1.5-3.4,3.2-6.7,5.6-8.8c2.8-2.4,6.2-3,9.4-3.7c3.5-0.8,7.3-1.7,10.9-3.2c2.5-1.1,4.9-2.5,7-4.5 c5.3-4.9,8.7-2,14.2,0.8c3.4,1.7,7.1,1.6,10.6,3c0.7,0.3,1.5,0.7,2.2,1.3c0.7-0.6,1.4-1,2.2-1.3c3.5-1.4,7.2-1.3,10.6-3 c5.5-2.7,9-5.7,14.2-0.8c0.9,0.8,1.8,1.6,2.8,2.2c4.6,3.1,10.1,4.4,15.1,5.5c3.2,0.7,6.6,1.3,9.4,3.7c2.4,2.1,4.1,5.4,5.6,8.8 C172.9,173.5,175.5,184.2,176.7,195.2z"
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M138.6,144.5c-0.6,0.7-1.1,1.3-1.7,1.9c-3.5,3.7-7,7.4-10.5,11c-1.4,1.5-2.8,2.9-3.9,4.6 c-3.5,5.1-4.7,11.4-5.6,17.6H94.7c0-2.2-0.5-4.4-1-6.5c-0.7-2.5-1.4-5-2.5-7.3c-2.3-4.8-6.1-8.6-10-12.1c-2.5-2.2-4.9-4.6-6.4-7.5 c2.5-0.8,4.9-1.8,7-3.2c5.3-3.5,8.7-1.4,14.2,0.6c3.4,1.2,7.1,1.1,10.6,2.1c0.7,0.2,1.5,0.5,2.2,0.9c0.7-0.4,1.4-0.7,2.2-0.9 c3.5-1,7.2-0.9,10.6-2.1c5.5-2,9-4.1,14.2-0.6C136.7,143.5,137.6,144.1,138.6,144.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000160882919625095057400000011433401166529395091_",
    gradientUnits: "userSpaceOnUse",
    x1: 84.5464,
    y1: 106.2174,
    x2: 144.5191,
    y2: 137.7647
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5A5A5A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5465,
    style: {
      stopColor: "#727272"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#898989"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000160882919625095057400000011433401166529395091_)"
    },
    d: "M129.7,108.3 c-0.7,5.8-2.7,11.6-5.6,17.1c-1.9,3.5-4.1,6.9-7.3,9.3c-2.6,2-6,3.5-9.4,3.4c-3.3,0.1-6.7-1.3-9.4-3.4c-3.2-2.4-5.4-5.8-7.3-9.3 c-2.5-4.7-4.3-9.6-5.2-14.5c2.2,2.3,5.9,2.5,9,1.6c3.1-1,5.9-2.8,8.8-4.2c1-0.4,1.9-0.8,3-0.9c2.5-0.2,4.8,1.3,7.1,2.4 c2.7,1.4,5.6,2.4,8.6,2.3c2.3-0.1,5.1-0.9,6.7-2.6C129,109.2,129.4,108.7,129.7,108.3z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M91.8,101.2c-0.4,0.9-0.2,1.9,0.1,2.8c0.5,1.5,1.6,3,3.1,3.6c1.6,0.6,6,0.7,6.4-1.6 c0.2-1.1-0.8-1.8-1.6-2.3c-1.1-0.7-2.3-1.3-3.6-1.7C94.7,101.6,93.2,101.3,91.8,101.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M123.1,101.2c0.4,0.9,0.2,1.9-0.1,2.8c-0.5,1.5-1.6,3-3.1,3.6c-1.6,0.6-6,0.7-6.4-1.6 c-0.2-1.1,0.8-1.8,1.6-2.3c1.1-0.7,2.3-1.3,3.6-1.7C120.1,101.6,121.6,101.3,123.1,101.2z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st19"
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 434,
    height: 328,
    xlinkHref: "A3C54253.png",
    transform: "matrix(0.24 0 0 0.24 55.3353 65.2238)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000029748159848923680910000007064123891102061489_",
    gradientUnits: "userSpaceOnUse",
    x1: 79.2789,
    y1: 116.2314,
    x2: 139.2518,
    y2: 147.7787
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5A5A5A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5465,
    style: {
      stopColor: "#727272"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#898989"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000029748159848923680910000007064123891102061489_)"
    },
    d: "M88.2,124.4c0.6,1.3,1.2,2.7,1.1,4.2 c-0.1,2.3-2.1,4.1-3.9,5.5c-0.3,0.2-0.6,0.5-0.7,0.8c0,0.2,0,0.5,0.1,0.7c0.3,0.9,0.6,1.8,0.9,2.7c-2.3,0.8-5.4-1.1-7.1,0.7 c-1.2,1.3-0.5,3.3,0.4,4.7c1,1.6,2.3,3.1,4,3.9c1.2,0.6,2.6,0.8,4,1.2c8.9,2.1,16.4,7.9,24.2,12.6c0.4,0.2,0.8,0.5,1.3,0.6 c1.1,0.1,2-0.7,2.7-1.5c5.6-5.8,11.2-11.7,15.9-18.2c0.7-0.9,1.3-2.2,0.6-3.1c-0.8-1.1-2.7-0.6-3.5-1.7c-0.6-0.8-0.2-2,0.5-2.8 c0.6-0.8,1.5-1.5,1.7-2.5c-1.9-1.1-3.7-2.3-5.6-3.4c-0.2-0.2-0.5-0.3-0.7-0.6c-0.3-0.5,0-1.1,0.3-1.7c2.2-4.3,3.6-9.1,4.1-13.9 c-1.7,2.4-4.1,4.2-6.8,5.2c-1.8,0.7-3.7,1-5.6,1.3c-3.9,0.5-7.8,0.8-11.7,0.8c-5.9,0-12.3-0.8-16.9-4.5c0.3,0.7,0.6,1.5,0.9,2.2 c-0.6-1.4-1.3-3.5-2.4-4.6C84.1,115.4,87.2,122.1,88.2,124.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000078764383029646290150000008779055294104059537_",
    gradientUnits: "userSpaceOnUse",
    x1: 132.5821,
    y1: 121.8742,
    x2: 98.844,
    y2: 74.7722
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 8.524463e-8,
    style: {
      stopColor: "#2D2D2D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3925,
    style: {
      stopColor: "#454545"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9951,
    style: {
      stopColor: "#717171"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000078764383029646290150000008779055294104059537_)"
    },
    d: "M87.5,79.7c0.1-0.3,0.2-0.6,0.5-0.9 c0.2-0.2,0.3-0.3,0.5-0.4c2.4-1.5,4.8-2.8,7.5-3.5c2.9-0.7,6.1-0.6,9.1-0.2c4.2,0.6,8.4,1.7,12.2,3.6s7.2,4.8,9.4,8.3 c1.3,2,2.2,4.1,2.9,6.4c1.1,3.4,1.8,7.1,1.4,10.7c-2.2-2.2-5.3-3-8.3-3.8c-5.7-1.5-11.6-3.4-16-7.4c1.2,1.8,2.6,3.5,4.1,5 c0.9,1,2,1.9,3.3,2.2c-5.1,0.9-10.4-0.2-14.9-2.7c-4.5-2.4-8.3-6.2-11.1-10.4C88,86.5,86.5,82.5,87.5,79.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000151542133305180907830000006621025646579408533_",
    gradientUnits: "userSpaceOnUse",
    x1: 136.0093,
    y1: 119.4193,
    x2: 102.2712,
    y2: 72.3174
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 8.524463e-8,
    style: {
      stopColor: "#2D2D2D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3925,
    style: {
      stopColor: "#454545"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9951,
    style: {
      stopColor: "#717171"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000151542133305180907830000006621025646579408533_)"
    },
    d: "M129.1,114.3c-0.1,4.6-1.6,9.2-4.5,12.9 c4.1-0.2,7.5-3.3,9.8-6.7c4.5-6.9,5.4-15.7,3.5-23.7c-0.5-2.1-1.1-4.1-2.2-5.9c-1.2-2-2.8-3.7-4.4-5.4c-2.1-2.2-4.2-4.4-6.3-6.7 c-2.5-2.6-4.9-5.2-7.6-7.6c-2.8-2.5-5.9-4.8-9.6-5.7c-6.1-1.4-12.5,1.6-17,6c-2.2,2.1-4.2,4.9-3.8,8c7,0.6,14,1.9,20.6,4.5 c5.2,2,10.4,4.9,14.5,8.8c3,2.8,3.7,7.3,5,11C128.3,107.2,129.2,110.7,129.1,114.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000110435844121571595370000003666761656490042809_",
    gradientUnits: "userSpaceOnUse",
    x1: 110.9746,
    y1: 137.3512,
    x2: 77.2364,
    y2: 90.2492
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 8.524463e-8,
    style: {
      stopColor: "#2D2D2D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3925,
    style: {
      stopColor: "#454545"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9951,
    style: {
      stopColor: "#717171"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000110435844121571595370000003666761656490042809_)"
    },
    d: "M87.7,96.4c-2.1,5-2.5,10.5-2,15.9 c0.5,5.4,1.8,10.6,3.1,15.9c-4.3-1.8-7.5-6-8.2-10.6c-0.9,3.8-0.5,8,1.2,11.6c-2.6-3.7-5.1-7.6-6.5-11.9c-1.4-4.3-1.7-9.1,0-13.3 c0.8-1.8,1.9-3.4,2.7-5.1c1-2,1.5-4.2,2-6.4c0.6-2.5,1.1-5,1.5-7.5c0.4-2.2,0.8-4.6,2.5-6c2.5-2.1,10.3-1.7,9.5,2.8 c-0.4,2.1-1.7,4-2.3,6C90.2,90.7,88.9,93.4,87.7,96.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000165205247587834059630000011285210621876328583_",
    gradientUnits: "userSpaceOnUse",
    x1: 122.8604,
    y1: 163.5466,
    x2: 121.6555,
    y2: 137.8049
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5A5A5A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5465,
    style: {
      stopColor: "#727272"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#898989"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000165205247587834059630000011285210621876328583_)"
    },
    d: "M118,125c-0.6,0.3-1.3,0.9-1.1,1.5 c0.1,0.3,0.3,0.5,0.5,0.6c1,0.8,2,1.5,3,2.3c0.2,0.2,0.5,0.4,0.6,0.7c0.1,0.4-0.1,0.7-0.2,1.1c-0.1,0.8,0.8,1.4,1.6,1.6 c0.8,0.2,1.7,0.2,2.4,0.6c-2.7,0.9-5.2,2.4-7.4,4.2c-0.7,0.6-1.4,1.3-1.3,2.2c1.2,0.5,2.4,1,3.6,1.5c0.3,0.1,0.5,0.2,0.6,0.5 c0.1,0.2,0,0.4-0.1,0.6c-0.4,1.2-0.9,2.3-1.6,3.3c1.1-1.4,2.5-2.7,4-3.7c0.6-0.4,1.2-0.8,1.9-0.9c0.7-0.1,1.5,0.2,1.8,0.8 c0.4,0.7,0,1.6-0.4,2.4c-1.4,2.6-3,5.5-5.8,6.7c0-0.3-0.1-0.6-0.1-0.9c-3.3,2.4-4.8,6.4-6.2,10.2c5.8-5.8,11.6-11.7,16.2-18.5 c0.3-0.5,0.6-1.1,0.3-1.5c-0.3-0.4-1-0.3-1.6-0.4c-1.5-0.1-2.4-1.9-2.2-3.4c0.2-1.5,1.3-2.7,2.2-3.9c-2.5-1.2-4.9-2.8-6.9-4.8 c0.3,0.3,3.6-5.9,3.8-6.5c0.7-2.1,1.6-5,1.1-7.2C125.2,118.7,122.4,122.6,118,125z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000005949460661017148420000015169286939812701317_",
    gradientUnits: "userSpaceOnUse",
    x1: 101.6847,
    y1: 145.0422,
    x2: 88.2257,
    y2: 135.9093
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5A5A5A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5465,
    style: {
      stopColor: "#727272"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#898989"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000005949460661017148420000015169286939812701317_)"
    },
    d: "M97.6,139.4c0.2,0.2,0.4,0.4,0.4,0.6 c-3-0.4-6-0.9-9-1.3c-0.9-0.1-1.9-0.3-2.4-1.1c0,0.1,0.3-1.6,0.3-1.7c0-0.5-0.2-0.7,0.3-1c0.7-0.5,2.5,0.2,3.1,0.5 C92.9,136.3,95.4,137.7,97.6,139.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000092453752741561994140000016576996472084487819_",
    gradientUnits: "userSpaceOnUse",
    x1: 62.9154,
    y1: 112.663,
    x2: 148.5184,
    y2: 112.663
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 4.795011e-8,
    style: {
      stopColor: "#282828"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2F2F2F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000092453752741561994140000016576996472084487819_)"
    },
    d: "M145.2,116.3c-2.3-7.8-4-15.8-6.5-23.6 c-2.5-7.8-5.8-15.4-11-21.7c-5.2-6.3-12.4-11.2-20.5-12.3c-0.5-0.1-1-0.3-1.5-0.2c-0.5,0-0.9,0.2-1.5,0.2 c-8.1,1.1-15.3,6-20.5,12.3c-5.2,6.3-8.5,13.9-11,21.7c-2.5,7.8-4.2,15.8-6.5,23.6c-2.1,7.2-4.7,14.9-2.4,22 c2.1,6.4,7.7,11,13.3,14.9c5.6,3.9,11.5,7.7,14.8,13.6c-3.6-10.2-13.4-16.9-20.2-25.4c-2.2-2.8-4.2-6.1-4.1-9.6 c0.1-1.9,0.8-3.8,1.4-5.6c2.4-6.3,4.8-12.6,7.2-19c2.8-7.4,5.6-14.8,9.9-21.4c2.2-3.4,4.8-6.5,7.9-9.1c3-2.6,10.9-4.6,11.7-4.8 c0.8,0.2,8.7,2.3,11.7,4.8c3.1,2.6,5.7,5.8,7.9,9.1c4.3,6.6,7.1,14,9.9,21.4c2.4,6.3,4.8,12.6,7.2,19c0.7,1.8,1.4,3.7,1.4,5.6 c0.1,3.6-1.9,6.8-4.1,9.6c-6.8,8.5-16.5,15.1-20.2,25.4c3.3-5.9,9.3-9.7,14.8-13.6c5.6-3.9,11.2-8.4,13.3-14.9 C149.9,131.2,147.3,123.5,145.2,116.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000135661354036093162490000011868785804101645753_",
    gradientUnits: "userSpaceOnUse",
    x1: 90.3383,
    y1: 90.0942,
    x2: 108.9342,
    y2: 90.0942
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 8.524463e-8,
    style: {
      stopColor: "#2D2D2D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3925,
    style: {
      stopColor: "#454545"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9951,
    style: {
      stopColor: "#717171"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000135661354036093162490000011868785804101645753_)"
    },
    d: "M98.7,92.5c-2.9-3.1-4.2-7.3-5.5-11.3 c-1,1.8-2.8,3.2-2.9,5.3c0,1.6,1.1,2.9,2.2,4c2.5,2.5,5.4,4.9,8.7,6.2c1.4,0.6,2.9,1,4.3,1.4c1.1,0.3,2.2,0.7,3.4,0.9 c0.1-0.9-4.3-2.2-5.1-2.7C102.9,95.8,98.7,93.7,98.7,92.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000029744132955996636310000018259384207643977138_",
    gradientUnits: "userSpaceOnUse",
    x1: 107.2603,
    y1: 92.3484,
    x2: 127.3375,
    y2: 92.3484
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 8.524463e-8,
    style: {
      stopColor: "#2D2D2D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3925,
    style: {
      stopColor: "#454545"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9951,
    style: {
      stopColor: "#717171"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000029744132955996636310000018259384207643977138_)"
    },
    d: "M108.2,84.3c-0.3,1.2-0.5,2.4-0.7,3.6 c-0.1,0.8-0.2,1.6-0.1,2.4c0.3,1.4,1.5,2.5,2.7,3.4c5.1,3.6,11.7,4.1,17.3,6.8c-0.5-0.2-0.7-1.4-1.1-1.8c-0.4-0.5-1.2-0.7-1.8-1 c-1.5-0.7-3.1-1.6-4.5-2.5c-2.9-1.8-5.6-4-8-6.4C110.6,87.4,109.3,85.9,108.2,84.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000135671047139436990930000008574213224687277982_",
    gradientUnits: "userSpaceOnUse",
    x1: 103.9413,
    y1: 159.9962,
    x2: 103.9413,
    y2: 107.3465
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 2.131116e-8,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "none",
      opacity: 0.2,
      fill: "url(#SVGID_00000135671047139436990930000008574213224687277982_)"
    },
    d: "M66.1,193.8 L12,102.5c0,0,183.9,0.4,183.9,0c0-0.4-51.7,91.3-51.7,91.3H66.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000178913010730782740670000011356836058623544232_",
    gradientUnits: "userSpaceOnUse",
    x1: 138.1333,
    y1: 152.4258,
    x2: 78.844,
    y2: 153.1554
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#229993"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 5.327789e-8,
    style: {
      stopColor: "#00C39A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2773,
    style: {
      stopColor: "#00AB87"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8602,
    style: {
      stopColor: "#006E56"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#005E4A"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000178913010730782740670000011356836058623544232_)"
    },
    points: "151.2,150.2 104.8,150.2  58.4,150.2 54.9,155.4 104.8,155.4 154.7,155.4  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000115507826675518150390000001268105047912926339_",
    gradientUnits: "userSpaceOnUse",
    x1: 54.8893,
    y1: 174.5842,
    x2: 154.7245,
    y2: 174.5842
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#229993"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 5.327789e-8,
    style: {
      stopColor: "#00C39A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2773,
    style: {
      stopColor: "#00AB87"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8602,
    style: {
      stopColor: "#006E56"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#005E4A"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000115507826675518150390000001268105047912926339_)"
    },
    points: "104.8,155.4 54.9,155.4  68.7,193.7 104.8,193.7 140.9,193.7 154.7,155.4  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000128460272463394245670000003825725759138037428_",
    gradientUnits: "userSpaceOnUse",
    x1: 104.8069,
    y1: 192.5182,
    x2: 104.8069,
    y2: 201.087
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#229993"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 5.327789e-8,
    style: {
      stopColor: "#00C39A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2773,
    style: {
      stopColor: "#00AB87"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8602,
    style: {
      stopColor: "#006E56"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#005E4A"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 65.8,
    y: 193.7,
    style: {
      fill: "url(#SVGID_00000128460272463394245670000003825725759138037428_)"
    },
    width: 78.1,
    height: 5.4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M113.1,178.1c0.9-0.5,1.5-1.5,1.7-2.5c-1,1.2-2.9,1.4-4.3,0.7c-1.4-0.7-2.4-2.1-2.8-3.6 c-0.4-1.5-0.3-3.1-0.1-4.6c-0.1,0.6-0.9,1.4-1.1,1.9c-0.4,0.7-0.7,1.5-0.9,2.2c-0.2,0.7-0.2,1.1-0.7,1.6c-0.3,0.3-1.6,0.3-1.8,0 c-0.5-0.5-0.5-0.9-0.7-1.6c-0.2-0.8-0.5-1.5-0.9-2.2c-0.3-0.5-1-1.3-1.1-1.9c0.3,1.5,0.4,3.1-0.1,4.6c-0.4,1.5-1.4,2.9-2.8,3.6 c-1.4,0.7-3.2,0.5-4.3-0.7c0.1,1,0.8,2,1.7,2.5c-0.8,0.6-1.5,1.3-2,2.2c1-0.5,2.2-0.3,3.3,0.1c2.9,1,5.2,3.6,6,6.6 c0.6,0.3,1.2,0.4,1.9,0.3c0.6,0.1,1.3-0.1,1.9-0.3c0.8-3,3.1-5.6,6-6.6c1.1-0.4,2.3-0.6,3.3-0.1 C114.6,179.4,113.9,178.7,113.1,178.1z"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000103956811130583555920000002072488658369019813_",
    gradientUnits: "userSpaceOnUse",
    x1: 134.6116,
    y1: 89.8543,
    x2: 134.6116,
    y2: -14.9933
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 5.327789e-8,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00C39A",
      stopOpacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 132.1,
    y: 27.3,
    style: {
      fill: "url(#SVGID_00000103956811130583555920000002072488658369019813_)"
    },
    width: 5.1,
    height: 5.1
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000134929279600262146540000002195919795884682921_",
    gradientUnits: "userSpaceOnUse",
    x1: 91.5898,
    y1: 165.0928,
    x2: 91.5898,
    y2: 60.2461
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 5.327789e-8,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00C39A",
      stopOpacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 88.7,
    y: 34.4,
    style: {
      fill: "url(#SVGID_00000134929279600262146540000002195919795884682921_)"
    },
    width: 5.8,
    height: 5.8
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000140700818286441614490000015770373517665615752_",
    gradientUnits: "userSpaceOnUse",
    x1: 122.7857,
    y1: 146.4543,
    x2: 122.7857,
    y2: 41.6076
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 5.327789e-8,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00C39A",
      stopOpacity: 0.1
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 119.4,
    y: 3.7,
    style: {
      fill: "url(#SVGID_00000140700818286441614490000015770373517665615752_)"
    },
    width: 6.9,
    height: 6.9
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000116204802064751122550000006449598687946981805_",
    gradientUnits: "userSpaceOnUse",
    x1: 118.3833,
    y1: 168.9848,
    x2: 118.3833,
    y2: 64.1384
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 5.327789e-8,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00C39A",
      stopOpacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 113.1,
    y: 37.3,
    style: {
      fill: "url(#SVGID_00000116204802064751122550000006449598687946981805_)"
    },
    width: 10.6,
    height: 10.6
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000129177428884197981850000016334368855010108063_",
    gradientUnits: "userSpaceOnUse",
    x1: 157.9624,
    y1: 135.1663,
    x2: 157.9624,
    y2: 30.3189
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 5.327789e-8,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00C39A",
      stopOpacity: 0.1
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 156.3,
    y: 21.8,
    style: {
      fill: "url(#SVGID_00000129177428884197981850000016334368855010108063_)"
    },
    width: 3.3,
    height: 3.3
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBannerBox);
export default __webpack_public_path__ + "static/media/banner-box.6cce5eab8240e5ccdf25e5583ef2ab7d.svg";
export { ForwardRef as ReactComponent };